import React from "react";
import { goTo } from "../../App";
import { ChevronDown } from "lucide-react";

export default function LessonPoints() {
  return (
    <section className="sec">
      <div className="mx-auto max-w-[1080px] px-4 lg:max-w-[1440px] lg:px-12">
        <div className="relative overflow-hidden rounded-2xl border border-white/10" data-testid="lesson-cover">
          <img
            src="/img/lesson-cover.webp"
            loading="lazy"
            alt="Claudio - High Ticket Sales"
            className="block w-full h-auto"
          />
          <div className="absolute left-[54%] top-[89%] -translate-x-1/2 -translate-y-1/2">
            <button
              onClick={() => goTo("prodotti")}
              className="btn btn-blue whitespace-nowrap !min-h-0 !px-3 !py-1.5 !text-[11px] !gap-1 sm:!min-h-[50px] sm:!gap-2 sm:!px-6 sm:!py-3 sm:!text-base"
              data-testid="lesson-cover-cta"
            >
              Scopri Sales Mastery 1.0 <ChevronDown size={16} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
